import React, { memo, useLayoutEffect } from 'react';
import {
    AwardsBlock,
    Footer,
    Header,
    CrewMembersBlock,
    PortfolioBlock,
    FAQsBlock,
    DegustationBlock,
    ImagesBlock,
    ContactsBlock,
    NavigationBlock,
    Breadcrumb,
    PlacesBlock,
    Toolbar,
} from 'widgets';
import { Error, PageLayout } from 'shared';
import { CulinaryStudioArticlePageMain } from './components';
import { useCulinaryStudioArticlePageState } from '../store';

const MemoBreadcrumb = memo(Breadcrumb);
const MemoFooter = memo(Footer);
const MemoAwardsBlock = memo(AwardsBlock);
const MemoPortfolioBlock = memo(PortfolioBlock);
const MemoPlacesBlock = memo(PlacesBlock);
const MemoFAQsBlock = memo(FAQsBlock);
const MemoDegustationBlock = memo(DegustationBlock);
const MemoImagesBlock = memo(ImagesBlock);
const MemoContactsBlock = memo(ContactsBlock);
const MemoNavigationBlock = memo(NavigationBlock);
const MemoMain = CulinaryStudioArticlePageMain;

export const CulinaryStudioArticlePage = () => {
    const {
        errors,
    } = useCulinaryStudioArticlePageState();

    useLayoutEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);
    return (
        <PageLayout
            toolbar={<Toolbar />}
        >
            <Header />
            <MemoBreadcrumb />
            {errors.length === 0 ? (
                <MemoMain />
            ) : (
                <Error
                    errors={errors}
                    margin="4rem 0"
                />
            )}
            <MemoAwardsBlock />
            <MemoImagesBlock />
            <MemoDegustationBlock />
            <CrewMembersBlock />
            <MemoPortfolioBlock />
            <MemoPlacesBlock />
            <MemoContactsBlock />
            <MemoFAQsBlock />
            <MemoNavigationBlock />
            <MemoFooter />
        </PageLayout>
    );
};
